import React, { FC } from 'react'
import DOMPurify from 'dompurify'
import { sanitizeHTML } from '../../../../utils/common-utils'
import { getFacetImagePath } from '../../../../utils/background-util'
import { CardHeroProps } from './CardHero.types'

import { PromoCard } from './PromoCard'
import { RTECompound } from '../../../Compounds/src/RTECompound'

export const CardHero: FC<CardHeroProps> = ({ content, testId }) => {
  const { heading, body, textAlignment, color, brandExtension, contentItems, noClip } = content

  const largeFacet = getFacetImagePath(color, { isMobile: false })
  const mobileFacet = getFacetImagePath(color, { isMobile: true })

  return (
    <section
      className={`CardsHero-Section ${brandExtension}`}
      data-analytics-container='Hero'
      data-analytics-component-template='Topic Front'
      data-analytics-component-name='Hero - Cards'
    >
      <img
        className={`HeroSectionFront-facet ${
          noClip ? 'HeroSectionFront-facet--noClip' : ''
        } u-sm-hidden`}
        src={DOMPurify.sanitize(largeFacet)}
        alt=''
        data-testid={testId ? `${testId}-facet` : null}
      />
      <img
        className={`HeroSectionFront-facet ${
          noClip ? 'HeroSectionFront-facet--noClip' : ''
        } u-md-hidden u-lg-hidden`}
        src={DOMPurify.sanitize(mobileFacet)}
        alt=''
        data-testid={testId ? `${testId}-facet-mobile` : null}
      />
      <div className='u-posRelative'>
        <div className='CardsHero-container'>
          <div className={'CardsHero u-sizeConstrained u-posRelative'}>
            <div
              className={`u-sm-sizeFill Content ${textAlignment}`}
              data-testid={testId ? `${testId}-box` : null}
            >
              <div className='u-paddingVert40'>
                <div className='CardsHero-heading u-paddingHoriz80 u-sm-paddingHoriz0 u-md-paddingHoriz0 u-textCenter'>
                  <h1
                    className='u-textSizeMsrp9 u-md-textSizeMsrp8 u-sm-textSizeMsrp7 pdf-textSize26'
                    data-testid={testId ? `${testId}-heading` : null}
                    dangerouslySetInnerHTML={{ __html: sanitizeHTML(heading ?? '') }}
                  ></h1>

                  <div
                    className={`Content u-marginTop6 pdf-textSize10 ${textAlignment}`}
                    data-testid={testId ? `${testId}-body` : null}
                  >
                    <RTECompound content={body?.content} />
                  </div>
                </div>
                <div className='u-paddingTop40 CardList'>
                  {contentItems?.length === 1 && (
                    <div className='u-textCenter CardFlex u-marginHoriz8'>
                      <div className={'Card u-padding0 u-posRelative u-bgColorWhite u-sizeFull'}>
                        <div className='Card-body card-content u-paddingHoriz80 u-md-paddingHoriz48 u-sm-paddingHoriz24 u-paddingVert40'>
                          <div className='card-description'>
                            <PromoCard {...contentItems[0]} />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {contentItems && contentItems?.length > 1 && (
                    <div className='RTE-Card-list u-flex  u-md-sizeFull u-sm-sizeFull u-md-flexCol u-sm-flexCol'>
                      {contentItems.map((content, index) => (
                        <div
                          className='u-textCenter CardFlex u-md-marginBottom24 u-sm-marginBottom24'
                          key={`RTECompound-${content.content?.eyebrowText}`}
                        >
                          <div
                            className={'Card u-padding0 u-posRelative u-bgColorWhite u-sizeFull'}
                          >
                            <div className='Card-body card-content'>
                              <div className='card-description RTE-Card'>
                                <RTECompound {...contentItems[index].content?.contentText} />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
